import styled from '@emotion/styled';

const QRStyles = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export default QRStyles;
